export const CHECKOUT_V2_BASE_PATH = "/v2";

export const CHECKOUT_V2_START_CHECKOUT_USER_PARAMETER = "userId";
export const CHECKOUT_V2_START_CHECKOUT_SUFFIX = `/start-checkout/:${
  CHECKOUT_V2_START_CHECKOUT_USER_PARAMETER
}`;
/** /v2/start-checkout/:userId */
export const CHECKOUT_V2_START_CHECKOUT_PATH = `${
  CHECKOUT_V2_BASE_PATH
}${
  CHECKOUT_V2_START_CHECKOUT_SUFFIX
}`;

export const DIRECT_SALES_CHECKOUT_V2_SUFFIX = "/start-checkout/direct-sales";
/** /v2/start-checkout/direct-sales */
export const DIRECT_SALES_CHECKOUT_V2_PATH = `${
  CHECKOUT_V2_BASE_PATH
}${
  DIRECT_SALES_CHECKOUT_V2_SUFFIX
}`;


export const CHECKOUT_PRICE_ESTIMATE_METHOD = "POST";
export const CHECKOUT_PRICE_ESTIMATE_SUFFIX = "price-estimate";
/** POST /price-estimate */
export const CHECKOUT_PRICE_ESTIMATE_PATH = CHECKOUT_PRICE_ESTIMATE_SUFFIX;

export const CHECKOUT_LEGACY_START_CHECKOUT_SUFFIX = "/start-checkout-for-basket";
/** /start-checkout-for-basket */
export const CHECKOUT_LEGACY_START_CHECKOUT_PATH = CHECKOUT_LEGACY_START_CHECKOUT_SUFFIX;

export const CHECKOUT_PAYMENTS_BASE_PATH = "/payments";

export const CHECKOUT_PAYMENTS_BASKET_CONFIRMED_SUFFIX = "/basket-confirmed";
/** /payments/basket-confirmed */
export const CHECKOUT_PAYMENTS_BASKET_CONFIRMED_PATH = `${
  CHECKOUT_PAYMENTS_BASE_PATH
}${
  CHECKOUT_PAYMENTS_BASKET_CONFIRMED_SUFFIX
}`;

export const CHECKOUT_CARD_READER_FETCH_ALL_METHOD = "GET";
export const CHECKOUT_CARD_READER_FETCH_ALL_SUFFIX = "/card-readers/list";
/** GET payments/card-readers/list */
export const CHECKOUT_CARD_READER_FETCH_ALL_PATH = `${
  CHECKOUT_PAYMENTS_BASE_PATH
}${
  CHECKOUT_CARD_READER_FETCH_ALL_SUFFIX
}`;

/** POST /checkout-session/expire */
export const CHECKOUT_V2_EXPIRE_SESSION_SUFFIX = "/checkout-sessions/expire";
export const CHECKOUT_V2_EXPIRE_SESSION_PATH = `${CHECKOUT_V2_BASE_PATH}${CHECKOUT_V2_EXPIRE_SESSION_SUFFIX}`;
